import { notification } from 'antd'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { decamelizeKeys, camelizeKeys } from 'humps'
import paths from '../routes/paths'
import LocalStorageService from './LocalStorageService'

class Interceptor {
  axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance

    this.setRequestInterceptor()
    this.setResponseInterceptor()
  }

  setRequestInterceptor(): void {
    this.axiosInstance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        const authToken = LocalStorageService.getAuthToken()

        if (config && config.headers) {
          if (authToken) {
            config.headers.Authorization = authToken
          }
        }

        if (config.convertRequestBodyToSnakeCase) {
          config.data = decamelizeKeys(config.data, {
            process: (key, convert, options) => {
              if (config.keysToAvoidConversion?.includes(key)) {
                return key
              }
              return convert(key, options)
            },
          })
        }

        return config
      },
      (error) => Promise.reject(error),
    )
  }

  setResponseInterceptor(): void {
    this.axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => {
        if (response.data && response.data.message) {
          notification.info({ message: response.data.message })
        }

        if (response.data) {
          if (
            response.headers['content-type'].includes('application/json') &&
            response.config.convertResponseBodyToCamelCase
          ) {
            return camelizeKeys(response.data)
          }
          return response.data
        }
        return response
      },

      ({ response: error }) => {
        console.log(error)
        if (error.data && error.data.message) {
          notification.error({ message: error.data.message })
        } else if (error.status === 401 || error.status === 403) {
          LocalStorageService.removeAuthToken()
          if (window.location.pathname !== paths.login) {
            window.location.href = paths.login
          }
        } else {
          notification.error({ message: 'Beklenmedik bir hata oluştu!' })
        }
        return Promise.reject(error)
      },
    )
  }
}

export default Interceptor
